var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightening(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.5,
    r: 11.5,
    fill: "#28B672"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6778 11.0651L13.4263 9.18067L15.0655 5.2469C15.1227 5.13006 15.1493 5.00063 15.1429 4.8707C15.1364 4.74077 15.0971 4.61461 15.0286 4.504C14.9602 4.3934 14.8648 4.30197 14.7513 4.23828C14.6379 4.17459 14.5102 4.14072 14.3801 4.13983C14.2072 4.13942 14.0392 4.19721 13.9032 4.3039L13.8495 4.3499L8.09955 9.79323C8.01311 9.87532 7.94696 9.9764 7.90634 10.0885C7.86571 10.2005 7.85173 10.3205 7.86549 10.4389C7.87925 10.5574 7.92037 10.6709 7.98562 10.7707C8.05086 10.8705 8.13842 10.9537 8.24138 11.0138L11.4936 12.8998L9.83528 16.8788C9.76688 17.0411 9.75651 17.222 9.80592 17.391C9.85532 17.5601 9.96148 17.707 10.1065 17.8069C10.2515 17.9068 10.4266 17.9537 10.6022 17.9397C10.7777 17.9256 10.9431 17.8515 11.0704 17.7298L16.8204 12.2849C16.9066 12.2028 16.9726 12.1017 17.0131 11.9897C17.0536 11.8776 17.0674 11.7577 17.0536 11.6394C17.0398 11.5211 16.9986 11.4076 16.9334 11.308C16.8682 11.2083 16.7807 11.1252 16.6778 11.0651V11.0651Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightening);
export default __webpack_public_path__ + "static/media/lightening.bee02865dc9c426b12155e646e83b491.svg";
export { ForwardRef as ReactComponent };